let host = 'cn-hangzhou.log.aliyuncs.com'; // 日志服务的域名
import SlsTracker from '@aliyun-sls/web-track-browser'; // sls 日志服务上报
import router from '@/router';
import { ALIYUN_PROJECT_NAME, ALIYUN_LOG_STORE, ALIYUN_IR_LOG_STORE } from '@/fetch/host';
import { customAlphabet } from 'nanoid';
import { isBuild, IR_VERSION, isApp, isWx, isWxMiniProgram, isWxWork, isOpenHarmony } from './const';
import { getUserInfo, debounce, getCookie, checkUndefined } from './api';
import packageJson from '../../package.json';

const opts = {
	host: `${host}`, // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
	project: `${ALIYUN_PROJECT_NAME}`, // Project名称。
	logstore: `${ALIYUN_LOG_STORE}`, // Logstore名称。
	time: 10, // 发送日志的时间间隔，默认是10秒。
	count: 10, // 发送日志的数量大小，默认是10条。
	topic: 'topic', // 自定义日志主题。
	source: 'irm-mobile' // 自定义日志来源。
};

// 企业号埋点实例 在另外的实例
const irstoreOpts = {
	host: `${host}`, // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
	project: `${ALIYUN_PROJECT_NAME}`, // Project名称。
	logstore: `${ALIYUN_IR_LOG_STORE}`, // Logstore名称。
	time: 10, // 发送日志的时间间隔，默认是10秒。
	count: 10, // 发送日志的数量大小，默认是10条。
	topic: 'topic', // 自定义日志主题。
	source: 'irm-mobile', // 自定义日志来源。
	module: 'irstore' // 标识企业号埋点
};

const environmentChecks = [
	{
		env: 'thirdMiniProgram',
		check: () => {
			// 单独提供的三方定制小程序
			const comein_channel = localStorage.getItem('channel');
			const isThirdMiniProgram = isWxMiniProgram && !checkUndefined(comein_channel);
			return isThirdMiniProgram;
		}
	},
	{ env: 'miniProgram', check: () => isWxMiniProgram }, // 剩下的就是进门小程序
	{ env: 'wxWork', check: () => isWxWork },
	{ env: 'wx', check: () => isWx },
	{ env: 'openHarmony', check: () => isOpenHarmony },
	{ env: 'app', check: () => isApp }
];
function detectEnvironment() {
	for (let i = 0; i < environmentChecks.length; i++) {
		const data = environmentChecks[i];
		if (data.check()) {
			return data.env;
		}
	}
	return 'browser';
}
function filterTrackData(data, isIR) {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	let token = sessionStorage.getItem('sessionToken');
	if (!token) {
		token = customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', 36)();
		sessionStorage.setItem('sessionToken', token);
		sessionStorage.setItem('sequence', 0);
	}

	let preData = {
		version: packageJson.version,
		env: isBuild ? 'prod' : 'dev'
	};
	if (isIR) {
		const isRelease = getCookie('release') === 'pro_001';
		preData.version = IR_VERSION;
		preData.env = isRelease ? 'release' : isBuild ? 'prod' : 'dev';
		preData.platform = detectEnvironment();
	}

	return {
		session: token,
		sequence: sessionStorage.getItem('sequence') || 0,
		uid: urlParams.get('uid') || getUserInfo()?.uid,
		userAgent: navigator.userAgent,
		...preData,
		...data
	};
}

class BaseSendTracker {
	constructor(config) {
		const { module, ...coreConfig } = config;

		this.isIRTrack = module === 'irstore';

		this.tracker = new SlsTracker(coreConfig);
		// 将send方法替换为防抖后的版本
		this.send = debounce(this.send.bind(this), 500);
	}

	generateOption(data) {
		const currentRoute = router.currentRoute;
		let title = currentRoute.path === '/conference/conference_detail' ? '会议详情' : currentRoute.meta?.title;
		sessionStorage.setItem('sequence', Number(sessionStorage.getItem('sequence')) + 1);
		let extraData = {
			// 额外的公共数据
			timestamp: Date.now(),
			module: currentRoute.matched[1]?.meta?.module || '沟通管理',
			curPage: title || '',
			fullPath: currentRoute.fullPath,
			event: 'CLICK',
			client: 'web',
			agent: 'h5',
			source: 'irm-mobile'
		};

		let log = { ...extraData, ...data };
		log.event = log?.event?.toLocaleUpperCase();

		// 阿里云要求对象的值必须是字符串
		for (let key in log) {
			if (typeof log[key] !== 'string') {
				log[key] = JSON.stringify(log[key]);
			}
		}

		return filterTrackData(log, this.isIRTrack);
	}

	send(data) {
		// 发送日志提供了4种方式  send 延时单条  sendImmediate 立即单条  sendBatchLogs 延时批量  sendBatchLogsImmediate 立即批量
		this.tracker.sendImmediate(this.generateOption(data)); // 发送日志
	}
}
class IrmSendTracker extends BaseSendTracker {
	constructor() {
		super(opts);
	}
}
class IrstoreSendTracker extends BaseSendTracker {
	constructor() {
		super(irstoreOpts);
	}

	send(data) {
		const shouldReturnExecute = Boolean(sessionStorage.getItem('ir_from_preview'));
		if (shouldReturnExecute) {
			console.log('---- 预览模式下不会记录埋点');
			return;
		}
		super.send(data);
	}
}

export const Tracker = new IrmSendTracker();
export const IrstoreTracker = new IrstoreSendTracker();
